import { useEffect } from "react";
import useAppBrandInfo from "../hooks/useAppBrandInfo";

export default function BrandMetadataSync() {
  const brandInfo = useAppBrandInfo();

  useEffect(() => {
    if (!brandInfo) return;

    // 1. Dynamic document.title (${product_name} | ${app_name})
    if (brandInfo.product_name && brandInfo.app_name) {
      document.title = `${brandInfo.product_name} | ${brandInfo.app_name}`;
    }

    // 2. Dynamic favicon (<link rel="icon">)
    if (brandInfo.fav_icon_url) {
      let faviconLink = document.querySelector("link[rel*='icon']");
      if (!faviconLink) {
        faviconLink = document.createElement("link");
        faviconLink.rel = "icon";
        document.head.appendChild(faviconLink);
      }
      faviconLink.href = brandInfo.fav_icon_url;
    }

    // 3. Dynamic meta description (<meta name="description">)
    if (brandInfo.product_description) {
      let metaDesc = document.querySelector("meta[name='description']");
      if (!metaDesc) {
        metaDesc = document.createElement("meta");
        metaDesc.name = "description";
        document.head.appendChild(metaDesc);
      }
      metaDesc.content = brandInfo.product_description;
    }
  }, [brandInfo]);

  return null;
}
